module.exports = __webpack_public_path__ + "media/mediapal-hero-video.f9399b36.mp4";